module.exports = __webpack_public_path__ + "img/shareLink.e0a2687b.png";